import * as React from 'react'
import { cn } from '#app/utils/misc.tsx'

/** Thin progress bar (prototype `.progress`). value 0–100. */
export function ProgressBar({ value, className, tone = 'ink' }: { value: number; className?: string; tone?: 'ink' | 'accent' | 'ok' }) {
	const bar = { ink: 'bg-ink', accent: 'bg-brown', ok: 'bg-ok' }[tone]
	return (
		<div role="progressbar" aria-valuenow={Math.round(value)} aria-valuemin={0} aria-valuemax={100} className={cn('h-1 overflow-hidden rounded-sm bg-line', className)}>
			<span className={cn('block h-full transition-[width] duration-500 ease-dna', bar)} style={{ width: `${Math.max(0, Math.min(100, value))}%` }} />
		</div>
	)
}

/** Segmented step indicator (onboarding). */
export function Steps({ total, current, labels, className }: { total: number; current: number; labels?: string[]; className?: string }) {
	return (
		<div className={className}>
			<div className="flex gap-1.5">
				{Array.from({ length: total }, (_, i) => (
					<span key={i} className={cn('h-[3px] flex-1 rounded-sm transition-colors duration-300', i < current ? 'bg-ink' : 'bg-line')} />
				))}
			</div>
			{labels ? (
				<div className="mt-3 hidden gap-1.5 sm:flex">
					{labels.map((l, i) => (
						<span key={l} className={cn('flex-1 font-mono text-[10px] uppercase tracking-[.12em]', i < current ? 'text-ink' : 'text-stone')}>
							{String(i + 1).padStart(2, '0')} · {l}
						</span>
					))}
				</div>
			) : null}
		</div>
	)
}

/** Segmented ratio bar (RSVP split). */
export function SplitBar({ parts, className }: { parts: Array<{ value: number; tone: 'ok' | 'bad' | 'warn' | 'none' | 'ink' | 'accent' }>; className?: string }) {
	const total = parts.reduce((n, p) => n + p.value, 0) || 1
	const bg = { ok: 'bg-ok', bad: 'bg-bad', warn: 'bg-warn-dot', none: 'bg-line', ink: 'bg-ink', accent: 'bg-brown' }
	return (
		<div className={cn('flex h-2 gap-0.5', className)}>
			{parts.map((p, i) => (p.value ? <span key={i} className={bg[p.tone]} style={{ width: `${(p.value / total) * 100}%` }} /> : null))}
		</div>
	)
}
